import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Loading from '@hellodarwin/core/lib/components/loading';
import useHubspotFormLoader from './hooks/useHubspotFormLoader';
import { HubspotFormLoadingState, StyledHubspotFormContainer } from './styles';
const HubspotFormEmbed = ({ additionalFields, assignedTheme = 'Full Width', dataLpUrl, formId, hubspotId, isLegacy = false, minHeight, }) => {
    const { formElement, isLoading } = useHubspotFormLoader({
        formId,
        hubspotId,
        isLegacy,
        additionalFields,
    });
    return (_jsxs(_Fragment, { children: [isLoading && isLegacy && (_jsx(HubspotFormLoadingState, { "$minHeight": minHeight, children: _jsx(Loading, {}) })), _jsx(StyledHubspotFormContainer, { ref: formElement, id: formId, className: "hs-form-html", "data-region": "na1", "data-form-id": hubspotId, "data-portal-id": "21902860", "data-lp-url": dataLpUrl, "$assignedTheme": assignedTheme, "$isLegacy": isLegacy })] }));
};
export default HubspotFormEmbed;
